let nodeEnv = process.env.NODE_ENV;//当前环境
//封面新闻接口地址
let HTTP_URL = 'https://rmt-api.dachuan.org.cn';
//活动接口地址
let ACTIVITY_URL = 'https://actapi.dachuan.org.cn';

export default {
    //安卓下载apk地址
    DOWNLOAD_ADDRESS: 'https://rmt-api.dachuan.org.cn/download.js',
    //scheme地址
    APP_SCHEME_URL: 'dachuan://cn.dachuan.www', 
    // wap地址前缀
    WAP_ADDRESS: 'http://m.dachuan.org.cn/',
    //微信里面scheme地址
    WEIXIN_APP_SCHEME_URL: 'http://0.0.0.0:22051', 
    //UniversalLink地址
    UNIVERSALLINK: 'https://wapcdn.dachuan.org.cn/UniversalLinks/index.html',
    //封面新闻接口地址
    HTTP_URL,
    //活动接口地址 
    ACTIVITY_URL, 
    // 七牛图片服务器地址
    QINIUDOMAIN: 'https://acticdn.dachuan.org.cn/',
	HUAWEIDOMAIN: "https://acticdn.dachuan.org.cn/",	
    //微信应用宝地址
    WEXIN_APP_DOWNLOAD_ADDRESS: "https://a.app.qq.com/o/simple.jsp?pkgname=com.dachuan.news",
   
    ApiToken: sessionStorage.getItem('TOKEN'),
    Api_sign_root: '12345678',
    wx_appid: 'wx3d7206ee052f3e73',
    //当前时间戳
    timestamp: new Date().getTime(),
    // 请求接口地址
    apiurl: {
        'qiNiuToken': '/qiniu/tokenkey', //获取七牛token
        'aLiPayLogin': '/wap/aLiPayLogin', // 获取支付宝授权用户的登录
        'weixingetConf': '/wap/weixin/getConf', // 获取微信配置信息
        'recordActivityClickRate': '/activity/recordActivityClickRate', // 记录活动点击量
        'setMessageInfo': '/activity/setMessageInfo', // 存储消息信息
    },
	Tenantid: 15,  // 租户ID
	TFUNION_WEIXIN_SHARE_URL: '',  // 天府联合体微信分享接口地址
}